import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private isLoading: boolean = false;
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading1: Observable<boolean> = this.loadingSubject.asObservable();
    show(): void {
        this.isLoading = true;
    }

    hide(): void {
        this.isLoading = false;
    }

    getLoadingState(): boolean {
        return this.isLoading;
    }
}
